"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeOutManagerBase = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const types_1 = require("../types");
const features_1 = require("../../features");
const tracker_1 = require("../../tracker");
const useManagerTimeoutBase_1 = require("../hooks/useManagerTimeoutBase");
const TimeOutManagerBase = ({ config, timeout }) => {
    const { data: { isExpired, isWarning, countDown }, redirect, handleRefresh, handleFinnish, } = (0, useManagerTimeoutBase_1.useManagerTimeoutBase)(timeout);
    const [type, setType] = React.useState(null);
    React.useEffect(() => {
        if (isExpired) {
            setType(types_1.TimeOutType.ExpiredTimeOut);
            tracker_1.tracker.track(features_1.TimeOutTrackingActions.TIMEOUT_MODAL_EXPIRED_VIEW);
        }
        else if (isWarning) {
            setType(types_1.TimeOutType.WarningTimeOut);
            tracker_1.tracker.track(features_1.TimeOutTrackingActions.TIMEOUT_MODAL_WARNING_VIEW);
        }
        else {
            setType(null);
        }
    }, [isExpired, isWarning]);
    const Component = type && config[type];
    if (!Component) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(Component, { isOpen: true, redirect: redirect, handleRefresh: handleRefresh, handleFinnish: handleFinnish, countDown: countDown });
};
exports.TimeOutManagerBase = TimeOutManagerBase;
//# sourceMappingURL=managerBase.js.map